import React from "react";
import { useNavigate } from "react-router-dom";

function SelectOption() {
  const Navigate = useNavigate();
  return (
    <div className="flex space-x-15 md:space-x-10 sm:space-x-5">
      <div
        className="bg-white shadow-lg border-cyan-100 border-1 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat"
        onClick={() => Navigate("/dashboard/management/items/add-Item")}
      >
        <div className="flex flex-col items-center py-4 font-Montserrat">
          <h2 className="font-Montserrat font-medium text-lg mb-4">Item</h2>
          <svg
            width="122"
            height="132"
            viewBox="0 0 122 132"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M86.7235 98.274L84.837 99.3465V89.903L86.7235 88.8305V98.274ZM102.25 79.9865L100.369 81.059V90.5025L102.25 89.43V79.9865ZM121.5 38.1755V101.464L67.875 132L0.5 93.621V30.3325L54.2185 0L121.5 38.1755ZM45.347 17.644L94.968 46.123L104.318 41.0795L54.1965 12.6445L45.347 17.644ZM61 70.884L11.5 42.185V87.23L61 115.423V70.884ZM77.6155 55.4345L29.111 26.741L17.869 33.1595L66.599 61.4185L77.6155 55.4345ZM110.5 50.248L99.5 56.177V71.5L83 80.784V65.076L72 71.005V116.996L110.5 95.0785V50.248ZM83.5115 90.662L81.592 91.7565V101.178L83.5115 100.105V90.662ZM91.239 86.262L89.347 87.34V96.7835L91.239 95.7055V86.262ZM94.396 84.4635L92.5095 85.536V94.9795L94.396 93.907V84.4635ZM97.608 82.632L95.683 83.7265V93.17L97.608 92.0755V82.632Z"
              fill="#4B93C3"
            />
          </svg>
        </div>
      </div>
      <div
        className="bg-white shadow-lg border-cyan-100 border-1 rounded-lg hover:shadow-xl hover:border-blue-200 w-full align-middle font-Montserrat"
        onClick={() => Navigate("/dashboard/management/items/add-assembly")}
      >
        <div className="flex flex-col items-center py-4 font-Montserrat">
          <h2 className="font-Montserrat font-medium text-lg mb-4">Assembly</h2>
          <svg
            width="106"
            height="152"
            viewBox="0 0 106 152"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M82.4596 74.4293V102.042L58.971 115.283L29.5078 98.7012V70.9688L59.0192 87.7909L82.4596 74.4293ZM55.9596 88.8483L34.2778 76.3038V95.8174L55.9596 108.146V88.8483ZM77.6414 79.8364L72.8233 82.4318V88.8483L65.596 92.9096V86.1327L60.7778 88.7281V108.819L77.6414 99.2059V79.8364Z"
              fill="#4B93C3"
            />
            <path
              d="M82.2656 74.4223L105.995 61.1328V88.8413L82.4583 102.083C82.4583 92.8786 82.4584 83.7466 82.2656 74.5425V74.4223ZM101.177 66.3236L96.3588 68.895V75.5998L89.1315 79.6612V72.7881L84.3133 75.3836V95.474L101.177 85.8613V66.3236Z"
              fill="#4B93C3"
            />
            <path
              d="M29.5355 71.067V98.7034L0 81.9293V54.293L29.5355 71.067ZM26.5 71.8841L4.81818 59.3636V79.0455L26.5 91.2536V71.8841Z"
              fill="#4B93C3"
            />
            <path
              d="M82.4596 46.7365V74.421L58.971 87.7826L29.5078 71.0325V43.3L52.9965 30.0586L82.4596 46.7365ZM49.1178 37.7487L70.7996 50.1971L74.8951 47.9862L52.9965 35.5618L49.1178 37.7487ZM55.9596 61.0113L34.2778 48.4908V68.1727L55.9596 80.4769V61.0113ZM63.1869 54.2584L42.011 41.738L37.1928 44.5256L58.5374 56.8779L63.1869 54.2584ZM77.6414 51.9995L72.8233 54.5949V61.2997L65.596 65.337V58.488L60.7778 61.0834V81.1739L77.6414 71.5612V51.9995Z"
              fill="#4B93C3"
            />
            <path
              d="M106 33.5721V61.1364L82.4632 74.4259C82.4632 65.2218 82.4632 56.1138 82.2705 46.8857L53 30.0635L76.5368 16.75L106 33.5721ZM72.61 24.4161L94.2918 36.8645L98.3873 34.6536L76.4405 22.2292L72.61 24.4161ZM86.7273 40.9258L65.4791 28.4053L60.6609 31.193L81.9091 43.5453L86.7273 40.9258ZM101.182 38.6668L96.3636 41.2623V47.9911L89.1364 52.0524V45.1554L84.3182 47.7268V67.8412L101.182 58.2286V38.6668Z"
              fill="#4B93C3"
            />
            <path
              d="M53 30.2335L29.5355 43.4268V71.0392L0 54.2891V26.6287L23.5368 13.3633L53 30.2335ZM19.5859 20.9813L41.2677 33.4297L45.3632 31.2188L23.4164 18.7944L19.5859 20.9813ZM26.5 44.2439L4.81818 31.6994V51.3813L26.5 63.7095V44.2439ZM33.7273 37.491L12.4791 24.9465L7.54045 27.7582L28.9091 40.1105L33.7273 37.491Z"
              fill="#4B93C3"
            />
            <path
              d="M52.7372 30.2297C43.1009 24.6303 33.2959 18.9588 23.5391 13.4075L47.0036 -0.0742188L76.5391 16.7479L52.7372 30.1816V30.2297ZM43.1009 7.59187L64.7827 20.0162L68.8781 17.8293L46.9554 5.45305L43.1009 7.59187ZM57.2422 24.1016L35.9941 11.5571L31.1759 14.3688L52.5204 26.697L57.2422 24.1016Z"
              fill="#4B93C3"
            />
            <path
              d="M82.4596 102.038V129.698L58.971 143.036L29.5078 126.358V98.6016L59.0192 115.424L82.4596 102.038ZM55.9596 116.337L34.2778 103.792V123.474L55.9596 135.803V116.337ZM77.6414 107.325L72.8233 109.896V116.601L65.596 120.663V113.79L60.7778 116.385V136.475L77.6414 126.863V107.325Z"
              fill="#4B93C3"
            />
            <path
              d="M82.2656 102.157L105.995 88.8438V116.48L82.4583 129.697C82.4583 120.493 82.4584 111.361 82.2656 102.157ZM101.177 93.9625L96.3588 96.5579V103.263L89.1315 107.324V100.451L84.3133 103.046V123.137L101.177 113.524V93.9625Z"
              fill="#4B93C3"
            />
            <path
              d="M29.5355 98.7278V126.364L0 109.59V81.9297L29.5355 98.7278ZM26.5 99.5449L4.81818 87.0004V106.682L26.5 119.01V99.5449Z"
              fill="#4B93C3"
            />
            <path
              d="M82.4596 129.696V138.66L58.971 152.021L29.5078 135.343V126.355L59.0192 143.033L82.4596 129.696ZM55.9596 141.327L34.2778 129.047V132.46L55.9596 144.764V141.327ZM77.6414 132.435L60.7778 142.048L58.971 143.081L60.7778 142.048V145.509L77.6414 135.896V132.435Z"
              fill="#4B93C3"
            />
            <path
              d="M84.3159 128.67L105.998 116.438V125.425L82.4609 138.667V129.727L84.3159 128.67ZM101.18 119.177L84.3159 128.67V132.106L101.18 122.493V119.177Z"
              fill="#4B93C3"
            />
            <path
              d="M29.5114 126.384V135.348L0 118.574V109.586L29.5114 126.384ZM26.5 124.63L4.81818 112.302V115.666L26.5 127.994V124.63Z"
              fill="#4B93C3"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default SelectOption;
